import { Option } from '@code/innovance-react-ui-kit';

import { Document } from 'src/front/api/apiInstance';
import {
  UpdateDocumentRequest,
  UpdateDocumentResponse,
  UploadDocumentResponse,
  UploadType,
} from 'src/front/api/generated';
import { UploadDocumentFormData } from 'src/front/components/document/UploadDocumentModal';

export const createDocumentUpdateData = (
  formData: UploadDocumentFormData,
  uploadType?: UploadType,
  customerId?: string
): UpdateDocumentRequest => {
  const { documentId, explanation, documentType, documentName } = formData;
  return {
    documentId,
    explanation,
    documentType: documentType?.value || '',
    documentName,
    customerId,
    uploadType,
  };
};

export const uploadDocuments = async (
  formData: UploadDocumentFormData,
  uploadType?: UploadType,
  customerId?: string
): Promise<UploadDocumentResponse> => {
  const { explanation, documentType, files } = formData;
  const { data } = await Document.uploadDocuments(
    files && files[0],
    documentType?.value || '',
    uploadType || '',
    explanation,
    customerId
  );
  return data;
};

export const createDocumentFormData = (
  data: UploadDocumentResponse | UpdateDocumentResponse,
  formData: UploadDocumentFormData,
  documentTypes: Option[]
): UploadDocumentFormData => {
  const {
    explanation,
    isOldDocument,
    documentId,
    createDate,
    documentName,
    documentType: docType,
  } = data;
  const { filePath } = formData;
  return {
    documentType: documentTypes.find((type) => type.value === docType) || {
      value: docType,
      label: docType,
    },
    explanation,
    isOldDocument,
    documentId,
    createDate,
    filePath,
    documentName,
  };
};
